"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldViewer = void 0;
var React = require("react");
var _Core_1 = require("../../_Core");
var StringManipulator_1 = require("../../_Core/StringManipulator");
var Buttons_1 = require("../../Buttons");
var Highlighted_1 = require("../../Highlighted");
var Icon_1 = require("../../Icons/Icon/Icon");
var Localization_1 = require("../../Localization");
var Theme_1 = require("../../Theme");
var FieldViewer_styles_1 = require("./FieldViewer.styles");
var IconSize = {
    Height: "17px",
    Width: "17px",
};
var fieldViewerIconMarginRight = "0.5em";
var FieldViewer = /** @class */ (function (_super) {
    __extends(FieldViewer, _super);
    function FieldViewer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTableDetails = function () {
            if (_this.props.Table && _this.props.Table.length > 0) {
                return " (" + StringManipulator_1.PascalCaseToTitleCase(_this.props.Table) + ")";
            }
            else {
                return "";
            }
        };
        return _this;
    }
    FieldViewer.prototype.render = function () {
        return (React.createElement(FieldViewer_styles_1.Container, null,
            buildIcon(this.props.IconType),
            React.createElement("div", { style: { width: "calc(100% - " + IconSize.Width + " - " + fieldViewerIconMarginRight + ")" } },
                React.createElement(FieldViewer_styles_1.CaptionWrapper, null,
                    React.createElement(FieldViewer_styles_1.Caption, null,
                        React.createElement(Highlighted_1.Highlighted, { Highlight: this.props.Highlight, Text: "" + this.props.Caption + this.getTableDetails() })),
                    this.props.IsStandardFieldOrFormula &&
                        React.createElement(FieldViewer_styles_1.IconContainer, null,
                            "(",
                            React.createElement(Buttons_1.IconButton, { Icon: _Core_1.Icons.Function, OnClick: this.props.OnEditClicked, Title: Localization_1.strings.FieldViewer_Label_EditFunction, AriaLabel: Localization_1.strings.FieldViewer_Label_EditFunction, ButtonSize: "28px", IconSize: "24px", Color: Theme_1.Color.Blue.B60 }),
                            ")")),
                (this.props.ShowFieldPath && this.props.FieldPath) && React.createElement(FieldViewer_styles_1.FieldPath, null, this.props.FieldPath))));
    };
    return FieldViewer;
}(React.PureComponent));
exports.FieldViewer = FieldViewer;
var buildIcon = function (dataType) {
    if (dataType === "Boolean") {
        return (React.createElement(FieldViewer_styles_1.FieldViewerIcon, { MarginRight: fieldViewerIconMarginRight, Height: IconSize.Height },
            React.createElement(Icon_1.Icon, __assign({ Icon: _Core_1.Icons.FieldTypeBoolean }, IconSize))));
    }
    else if (dataType === "DateTime") {
        return (React.createElement(FieldViewer_styles_1.FieldViewerIcon, { MarginRight: fieldViewerIconMarginRight, Height: IconSize.Height },
            React.createElement(Icon_1.Icon, __assign({ Icon: _Core_1.Icons.FieldTypeDate }, IconSize))));
    }
    else if (dataType === "Number") {
        return (React.createElement(FieldViewer_styles_1.FieldViewerIcon, { MarginRight: fieldViewerIconMarginRight, Height: IconSize.Height },
            React.createElement(Icon_1.Icon, __assign({ Icon: _Core_1.Icons.FieldTypeInt }, IconSize))));
    }
    else if (dataType === "PrimaryKey") {
        return (React.createElement(FieldViewer_styles_1.FieldViewerIcon, { MarginRight: fieldViewerIconMarginRight, Height: IconSize.Height },
            React.createElement(Icon_1.Icon, __assign({ Icon: _Core_1.Icons.FieldTypeKey }, IconSize))));
    }
    return (React.createElement(FieldViewer_styles_1.FieldViewerIcon, { MarginRight: fieldViewerIconMarginRight, Height: IconSize.Height },
        React.createElement(Icon_1.Icon, __assign({ Icon: _Core_1.Icons.FieldTypeString }, IconSize))));
};
